import React, { useEffect, useState } from 'react'
import { CssBaseline } from '@mui/material'
import { ThemeProvider } from '@emotion/react'
import { createThemeApp } from '../../../theme'
import { useParams } from 'react-router-dom'
import AuthServiceTransient from '../../../service/AuthServiceTransient'
import { enqueueSnackbar, SnackbarProvider } from 'notistack'
import { extractErrorMessage } from '../../../utils/helper'

export function useIsAnyModalOpen() {
    const [isOpen, setIsOpen] = useState(false)

    useEffect(() => {
        const checkModal = () => {
            const modal = document.querySelector('.MuiModal-root, .MuiDialog-root')
            setIsOpen(!!modal)
        }

        checkModal()

        const observer = new MutationObserver(() => {
            checkModal()
        })

        observer.observe(document.body, {
            childList: true,
            subtree: true,
        })

        return () => observer.disconnect()
    }, [])

    return isOpen
}

export function useIsAnySnackbarOpen() {
    const [isOpen, setIsOpen] = useState(false)

    useEffect(() => {
        const checkSnackbar = () => {
            const snackbar = document.querySelector('.notistack-SnackbarContainer')
            setIsOpen(!!snackbar)
        }

        checkSnackbar()

        const observer = new MutationObserver(() => {
            checkSnackbar()
        })

        observer.observe(document.body, {
            childList: true,
            subtree: true,
        })

        return () => observer.disconnect()
    }, [])

    return isOpen
}

export function IframeDialogsWrapper({ children }) {
    const { jwt } = useParams()
    const [theme, setTheme] = useState()
    const isModalOpen = useIsAnyModalOpen()
    const isSnackbarOpen = useIsAnySnackbarOpen()

    useEffect(() => {
        AuthServiceTransient.load(jwt).then(async () => {
            console.log('Dados do usuário/empresa carregados com sucesso')
        }).catch(err => {
            console.log(err)
            extractErrorMessage(err, 'Erro ao carregar dados do usuário').then(msg => {
                enqueueSnackbar('Falha ao carregar dados do usuário/empresa carregados: ' + msg, { variant: 'error' })
            })
        })
    }, [jwt])

    useEffect(() => {
        setTheme(createThemeApp('light'))

        function changeTheme(message) {
            const { data } = message

            if (!data) return

            let dataJson = data

            if (typeof data === 'string') {
                try {
                    dataJson = JSON.parse(data)
                } catch (err) {
                    console.error('Erro ao fazer parse do tema:', err)
                    return
                }
            }

            if (dataJson?.newThemeMode) {
                const newTheme = createThemeApp(dataJson.newThemeMode)
                setTheme(newTheme)
            }
        }

        window.addEventListener('message', changeTheme)

        return () => {
            window.removeEventListener('message', changeTheme)
        }
    }, [])

    useEffect(() => {
        window.parent.postMessage({ type: 'fullscreen-event', active: isModalOpen, snackbarActive: isSnackbarOpen }, process.env.REACT_APP_RETAGUARDA_URL)
    }, [isModalOpen, isSnackbarOpen])

    if (!theme) {
        return null
    }

    return (
        <ThemeProvider theme={theme}>
            <SnackbarProvider
                disableWindowBlurListener
                maxSnack={3}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}>
                <CssBaseline />
                <style jsx="true" global="true">
                    {`body {
                        margin: 0;
                        overflow: hidden;
                        background-color: transparent;
                    }`}
                </style>
                {children}
            </SnackbarProvider>
        </ThemeProvider>
    )
}